

import { useClicksterStore } from '../index';

/**
 * Actions for managing profile modal state
 */
export const ProfileModalActions = {
    /**
     * Open the profile modal
     */
    open: () => {
        useClicksterStore.setState({ showProfileModal: true });
    },

    /**
     * Close the profile modal
     */
    close: () => {
        useClicksterStore.setState({ showProfileModal: false });
    },

    /**
     * Toggle the profile modal
     */
    toggle: () => {
        const currentState = useClicksterStore.getState().showProfileModal;
        useClicksterStore.setState({ showProfileModal: !currentState });
    },
};